// extracted by mini-css-extract-plugin
export default {"base":"kx5fA"};